import React from 'react'
import styles from '../../historySection.module.css'
import { DEFAULT_TEXT_UNRAISED_ESCALATION, DEFAULT_TEXT_RAISED_ESCALATION } from './defaultTextItem.constants'

export const DefaultTextItem = ({ isNoActivity }: { isNoActivity: boolean }) => {
    return (
        <div className={styles.historySectionContentItem}>
            <p className={styles.historySectionContentItemTitle}>
                { isNoActivity ? DEFAULT_TEXT_RAISED_ESCALATION : DEFAULT_TEXT_UNRAISED_ESCALATION }
            </p>
        </div>
    )
}
